module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loader-icon', {
    staticClass: "messages-loader-top",
    attrs: {
      "loading": _vm.isLoading === 'top'
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "messages",
    class: {
      loading: _vm.isLoading === true
    },
    attrs: {
      "id": "messages"
    }
  }, [(_vm.realTotalMessages > 10000 && _vm.currentPage === 1) ? _c('li', {
    staticClass: "msg-danger"
  }, [_vm._v("\n      Due to performance limitations only 10000 messages can be paginated. "), _c('br', {
    staticClass: "visible-lg"
  }), _vm._v("\n      Use search to filter all messages\n      "), (_vm.channel.channel_id) ? _c('span', [_vm._v("in this channel")]) : _vm._e(), _vm._v(" (" + _vm._s(_vm.realTotalMessages) + " messages).\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.messages), function(m) {
    return _c('li', {
      class: ['msg-type-' + m.subtype, {
        'msg-same-user': m.same_user,
        active: _vm.activeMessageId == m.ts_id
      }],
      attrs: {
        "id": m.ts_id
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (m.date_separator),
        expression: "m.date_separator"
      }],
      staticClass: "msg-date-separator"
    }, [_c('span', [_vm._v(_vm._s(m.date_separator))])]), _vm._v(" "), _c('div', {
      staticClass: "msg-avatar"
    }, [(m.user.profile && !m.same_user) ? _c('span', [_c('img', {
      staticClass: "msg-thumb",
      attrs: {
        "src": m.user.profile.image_48
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "msg-container"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!m.same_user),
        expression: "!m.same_user"
      }],
      staticClass: "msg-header"
    }, [_c('span', {
      staticClass: "msg-user"
    }, [_vm._v(_vm._s(m.user.name))]), _vm._v(" "), _c('span', {
      staticClass: "msg-time"
    }, [_c('a', {
      attrs: {
        "href": "",
        "rel": "nofollow"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.getMessageUrl(m)
        }
      }
    }, [_vm._v(_vm._s(m.date_str))]), _vm._v(" "), (_vm.search && _vm.targetMessageIdLoading == m.ts_id) ? _c('loader-icon', {
      staticClass: "messages-loader-msg",
      attrs: {
        "loading": 1
      }
    }) : _vm._e(), _vm._v(" "), (_vm.targetMessageError && _vm.targetMessageId == m.ts_id) ? _c('span', {
      staticClass: "msg-loading-error"
    }, [_vm._v(_vm._s(_vm.targetMessageError))]) : _vm._e(), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('div', {
      staticClass: "msg-body",
      domProps: {
        "innerHTML": _vm._s(m.text)
      }
    })]), _vm._v(" "), (m.isLast) ? _c('div', {
      staticClass: "msg-date-separator msg-end-separator"
    }, [_vm._m(0, true)]) : _vm._e()])
  }), _vm._v(" "), (_vm.totalMessages === 0 && _vm.channel) ? _c('li', [_c('div', {
    staticClass: "msg-date-separator msg-end-separator"
  }, [_c('span', [_c('em', [_vm._v("༄")]), _vm._v(" No messages in channel #" + _vm._s(_vm.channel.name) + " "), _c('em', {
    staticClass: "end-mark",
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("༄")])])])]) : _vm._e()], 2), _vm._v(" "), _c('loader-icon', {
    staticClass: "messages-loader-center",
    attrs: {
      "loading": _vm.isLoading === true,
      "size": 'sm'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "messages-loader-bottom"
  }, [_c('loader-icon', {
    attrs: {
      "loading": _vm.isLoading === 'bottom'
    }
  })], 1), _vm._v(" "), (_vm.appIsReady) ? _c('div', {
    staticClass: "pagination-container",
    attrs: {
      "id": "pagination"
    }
  }, [_c('paginate', {
    attrs: {
      "center-side": 2,
      "side": 1,
      "last-page": _vm.lastPage,
      "current-page": _vm.currentPage,
      "css-class": 'pagination-vertical',
      "next-text": '▼',
      "prev-text": '▲',
      "url-sync": false
    },
    on: {
      "turn": _vm.changePage
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("༄ No more new messages  "), _c('em', {
    staticClass: "end-mark",
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("༄")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-762833ab!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Messages.vue
// module id = 258
// module chunks = 2